<template>
  <v-container fluid>
    <v-text-field label="Date de début" type="date" v-model="dates.start" @change="getData"
      :loading="loading"></v-text-field>
    <v-text-field label="Date de fin" type="date" v-model="dates.end" @change="getData" :loading="loading"></v-text-field>
    <v-select label="Recherchez par Réseau" dense filled :items="networks" v-model="network" />
    <v-tabs v-model="tab">
      <v-tab>
        Paiement Prestataires
      </v-tab>
      <v-tab>
        Prélèvements Prévu
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <!-- Group By Réseau et Facilité -->
        <v-data-table :headers="header" :items="itemsFiltered" :loading="loading" :items-per-page="-1"
          :group-by="['main_facility']" class="elevation-1">


          <template v-slot:[`item.created_at`]="{ item }">
            {{ new Date(item.created_at).toLocaleDateString() }}
          </template>

          <template v-slot:[`item.total_price`]="{ item }">
            {{ (Math.round(item.total_price * 100) / 100).toFixed(2) }} €
          </template>

          <template v-slot:[`item.failed_to_pay`]="{ item }">
            <v-icon color="error" v-if="item.failed_to_pay">mdi-close</v-icon>
          </template>

          <template v-slot:[`item.transfered`]="{ item }">
            <v-icon v-if="item.transfered">mdi-check</v-icon>
          </template>

          <template v-slot:[`item.closed`]="{ item }">
            <v-icon v-if="item.closed">mdi-check</v-icon>
          </template>

          <template v-slot:[`group.summary`]="{ items }">
            <td></td>
            <td></td>
            <td></td>
            <td class="text-right font-weight-bold">Total Encaissé</td>
            <td class="text-right font-weight-bold">
              <!-- total encaissé --> 
              {{ (Math.round(items.reduce((acc, item) => acc + (item.payment.mode ? item.total_price : 0), 0) * 100) / 100).toFixed(2) }}€
            </td>
            <td></td>
            <td class="text-right font-weight-bold">Total Facture</td>
            <td class="text-right font-weight-bold">
              <!-- total subtract failed to pay -->
              {{ (Math.round((items.reduce((acc, item) => acc + item.total_price, 0) - items.reduce((acc, item) => acc +
                (item.failed_to_pay ? item.total_price : 0), 0)) * 100) / 100).toFixed(2) }}€
            </td>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>
                Prélevement total Utilisateurs
              </v-card-title>
              <v-card-text>
                <h1>
                  <template v-if="loading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </template>
                  <template v-else>
                    {{ getUsersPayinTotal }}€
                  </template>
                </h1>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card>
              <v-card-title>
                Prélevement total Conciergeries
              </v-card-title>
              <v-card-text>
                <h1>
                  <template v-if="loading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </template>
                  <template v-else>
                    {{ getConciergeriePayinTotal }}€
                  </template>
                </h1>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">

            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Conciergeries
                </v-expansion-panel-header>
              <v-expansion-panel-content>
                <!-- Group By Réseau et Facilité -->
                <v-data-table :headers="header" :items="onlyInternalItems" :loading="loading" :items-per-page="-1"
                  :group-by="['network']" class="elevation-1">

                  <template v-slot:[`item.created_at`]="{ item }">
                    {{ new Date(item.created_at).toLocaleDateString() }}
                  </template>

                  <template v-slot:[`item.total_price`]="{ item }">
                    {{ (Math.round(item.total_price * 100) / 100).toFixed(2) }} €
                  </template>

                  <template v-slot:[`item.payment.mode`]="{ item }">
                    {{ item.payment.mode }} 
                    <!-- icon info tooltip -->
                    <v-tooltip bottom v-if="item.payment.mode">
                      <template v-slot:activator="{ on }">
                        <v-icon color="info" v-on="on">mdi-information</v-icon>
                      </template>
                      <v-card>
                        <v-card-text>
                          <v-simple-table>
                            <template v-slot:default>
                              <tbody>
                                <tr>
                                  <td>Transaction ID</td>
                                  <td>{{ item._id }}</td>
                                </tr>
                                <tr>
                                  <td>Transaction Date</td>
                                  <td>{{ new Date(item.payment.updated_at).toLocaleDateString() }}</td>
                                </tr>
                                <tr>
                                  <td>Transaction Mode</td>
                                  <td>{{ item.payment.mode }}</td>
                                </tr>
                                <tr>
                                  <td>Transaction Amount</td>
                                  <td>{{ (Math.round(item.total_price * 100) / 100).toFixed(2) }} €</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-card-text>
                      </v-card>
                    </v-tooltip>

                  </template>

                  <template v-slot:[`item.failed_to_pay`]="{ item }">
                    <v-icon color="error" v-if="item.failed_to_pay">mdi-close</v-icon>
                  </template>

                  <template v-slot:[`item.transfered`]="{ item }">
                    <v-icon v-if="item.transfered">mdi-check</v-icon>
                  </template>

                  <template v-slot:[`item.closed`]="{ item }">
                    <v-icon v-if="item.closed">mdi-check</v-icon>
                  </template>

                  <template v-slot:[`group.summary`]="{ items }">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="text-right font-weight-bold">Total</td>
                    <td></td>
                    <td class="text-right font-weight-bold">
                      <!-- total subtract failed to pay -->
                      {{ (Math.round((items.reduce((acc, item) => acc + item.total_price, 0) - items.reduce((acc, item) => acc
                        + (item.failed_to_pay && item.payment.type == 'internal' && item.payment.mode ? item.total_price : 0), 0)) * 100) /
                        100).toFixed(2) }} €
                    </td>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>

                <v-expansion-panel-header>
                  Utilisateurs
                </v-expansion-panel-header>

                <v-expansion-panel-content>

                <v-data-table :headers="header" :items="onlyExternalItems" :loading="loading" :items-per-page="-1"
                  :group-by="['user.name']" class="elevation-1">

                  <template v-slot:[`item.created_at`]="{ item }">
                    {{ new Date(item.created_at).toLocaleDateString() }}
                  </template>

                  <template v-slot:[`item.total_price`]="{ item }">
                    {{ (Math.round(item.total_price * 100) / 100).toFixed(2) }} €
                  </template>

                  <template v-slot:[`item.failed_to_pay`]="{ item }">
                    <v-icon color="error" v-if="item.failed_to_pay">mdi-close</v-icon>
                  </template>

                  <template v-slot:[`item.transfered`]="{ item }">
                    <v-icon v-if="item.transfered">mdi-check</v-icon>
                  </template>

                  <template v-slot:[`item.closed`]="{ item }">
                    <v-icon v-if="item.closed">mdi-check</v-icon>
                  </template>

                  <template v-slot:[`group.summary`]="{ items }">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="text-right font-weight-bold">Total à prélever</td>
                    <td></td>
                    <td>
                    </td>
                    <td class="text-right font-weight-bold">
                      <!-- total subtract failed to pay -->
                      {{ (Math.round((items.reduce((acc, item) => acc + item.total_price, 0) - items.reduce((acc, item) => acc
                        + (item.failed_to_pay && !item.payment.mode ? item.total_price : 0), 0)) * 100) /
                        100).toFixed(2) }} €
                    </td>
                  </template>
                </v-data-table>

                </v-expansion-panel-content>
              </v-expansion-panel>
              </v-expansion-panels>

          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
/* eslint-disable */
import data from '@/assets/data.json'
import axios from 'axios'
export default {
  name: 'HomeView',
  computed: {
    onlyExternalItems()
    {
      return this.itemsFiltered.filter(map => !map.payment.mode)
    },
    onlyInternalItems()
    {
      return this.itemsFiltered.filter(map => map.payment.type == 'internal' && map.payment.mode)
    },
    getUsersPayinTotal() {
      let total = 0;
      let onlyUsers = this.itemsFiltered.filter(map => !map.payment.mode)
      onlyUsers.map(item => {
        total += item.total_price
      })
      return (Math.round(total * 100) / 100).toFixed(2)
    },
    getConciergeriePayinTotal() {
      let total = 0;
      let onlyUsers = this.itemsFiltered.filter(map => map.payment.type == 'internal' && map.failed_to_pay == false && map.payment.mode)
      onlyUsers.map(item => {
        total += item.total_price
      })
      return (Math.round(total * 100) / 100).toFixed(2)
    },
    networks() {
      if (!this.items) return []
      const networks = this.items.map(item => item.network)
      return [...new Set(networks)]
    },
    itemsFiltered() {
      if (!this.network) return this.items
      return this.items.filter(item => item.network === this.network)
    },
    header() {
      // failed_to_pay, status, transfered, closed, prestation.name, prestation.facility[0].name, payment.mode, network.name, total_price
      return [
        { text: 'ID', value: '_id'},
        { text: 'Créer le', value: 'created_at' },
        { text: 'Statut', value: 'status' },
        { text: 'Prestation', value: 'prestation.name' },
        { text: 'Facilité', value: 'main_facility' },
        { text: 'Mode.Paimnt', value: 'payment.mode' },
        { text: 'Réseau', value: 'network' },
        { text: 'Ech.Paimnt', value: 'failed_to_pay' },
        { text: 'Total', value: 'total_price', align: 'right' },
      ]
    }
  },
  data: () => ({
    tab: 1,
    data: [],
    items: [],
    network: null,
    loading: false,
    dates: {
      // debut du mois
      start: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
      // fin du mois
      end: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().substr(0, 10)
    }
  }),
  methods: {
    async getData() {
      this.loading = true;
      try {

        let res = await axios.get(`/api/prestations?start_date=${this.dates.start}&end_date=${this.dates.end}`)
        this.data = [];
        this.$nextTick(()=>{
          console.log('get data', res.data)
          this.data = res.data
          this.items = []
          this.data.map(item => {
            if (item.transfered) return;
            item.main_facility = item.prestation.facility.name
            item.network = item.network?.name
            this.items.push(item)
          })
        })
      } catch (err) {
        console.log(err)
      }
      this.loading = false
    }
  },
  async mounted() {
    this.dates.start = this.$moment().startOf('month').format('YYYY-MM-DD')
    this.dates.end = this.$moment().endOf('month').format('YYYY-MM-DD')
    await this.getData()
    
    console.log(this.items)
  }
}
</script>
